export interface ICheckListItem {
  index: number;
  description: string;
  route: string;
  test: (ICheckListItem) => boolean;

  errors?: string[];
  info?: string;
}

export abstract class ActivationBaseService {
  checklist: ICheckListItem[] = [];

  protected _activateErrors: ICheckListItem[] = [];

  constructor() {}

  protected addToChecklist(item: Partial<ICheckListItem>) {
    item.index = this.checklist.length + 1;
    this.checklist.push(<ICheckListItem>item);
  }

  protected executeTests() {
    this.activateErrors = this.checklist.filter((checkItem) => {
      // need to rebind 'this' for each test function
      const ok = checkItem.test.bind(this)(checkItem);
      checkItem.info = (checkItem.errors || []).join(' | ');
      return !ok;
    });

    return this.activateErrors.length > 0;
  }

  public get activateErrors(): ICheckListItem[] {
    return this._activateErrors;
  }

  public set activateErrors(value: ICheckListItem[]) {
    this._activateErrors = value;
  }

  public get hasErrors(): boolean {
    return this.activateErrors.length > 0;
  }

  public deactivate() {
    this.activateErrors = [];
  }

  public abstract routeTo(route: string): void;
}
